import { render, staticRenderFns } from "./LoadSetList.vue?vue&type=template&id=0581add4&scoped=true"
import script from "./LoadSetList.vue?vue&type=script&lang=js"
export * from "./LoadSetList.vue?vue&type=script&lang=js"
import style0 from "./LoadSetList.vue?vue&type=style&index=0&id=0581add4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0581add4",
  null
  
)

export default component.exports